<template>
  <div class="auth bg-info">
    <el-card class="content-card">
      <div class="pr-30">
        您没有使用该功能的权限，请联系管理员
      </div>
    </el-card>
  </div>
</template>

<script>
import { Card } from 'element-ui'

export default {
  name: 'permission-denied',
  components: { ElCard: Card },
}
</script>

<style lang="scss" scoped>
.auth {
  padding: 100px 20px;
  height: 100vh;
  box-sizing:border-box;
  -moz-box-sizing:border-box;
  -webkit-box-sizing:border-box;
}

.content-card {
  text-align: center;
  font-size: 1.3rem;
  max-width: 500px;
  width: 90%;
  margin: 0 auto;
  padding: 50px 0;
}
</style>
